export default "__VITE_ASSET__DcywKVwd__"